import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { CheckCircleIcon } from 'lucide-react';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="empezar" className="py-4 md:py-16 px-4 bg-brand-deep scroll-mt-10" data-id="element-210">
      <div className="max-w-5xl mx-auto" data-id="element-211">
        <div className="text-center mb-4 md:mb-8" data-id="element-212">
          <h2 className="text-2xl md:text-5xl font-black text-white mb-1 md:mb-4" data-id="element-213">
            Empezá tu camino hoy
          </h2>
        </div>

        <div className="max-w-md mx-auto bg-white rounded-3xl p-4 md:p-10 shadow-2xl border-4 border-brand-primary relative flex flex-col items-center text-center z-10" data-id="element-214">
          <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-brand-primary text-white font-black px-6 py-1.5 rounded-full text-xs tracking-widest shadow-md whitespace-nowrap" data-id="element-215">
            ❄️ ACCESO COMPLETO
          </div>

          <h3 className="text-xl md:text-3xl font-black text-brand-dark mb-3 md:mb-6 mt-1 md:mt-4" data-id="element-216">
            PACK DE REFRIGERACIÓN
          </h3>

          <div className="w-full h-px bg-gray-200 my-3 md:my-6" data-id="element-217"></div>

          <ul className="grid grid-cols-2 gap-x-2 gap-y-2 md:flex md:flex-col md:space-y-4 mb-4 md:mb-8 text-left w-full" data-id="element-218">
            {['5 Módulos Maestros', 'Clases grabadas paso a paso', 'Kit de Presupuestación', 'Checklist del Técnico', 'Guía de Primer Taller', 'Manuales Automotor'].map((item, i) => <li key={i} className="flex items-center gap-1.5 md:gap-3" data-id="element-219">
                <CheckCircleIcon className="w-4 h-4 md:w-6 md:h-6 text-brand-green flex-shrink-0" data-id="element-220" />
                <span className="text-gray-800 font-bold text-xs md:text-lg leading-tight" data-id="element-221">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="mt-auto text-center w-full" data-id="element-222">
            <div className="text-gray-400 text-lg md:text-2xl line-through font-bold mb-0.5" data-id="element-223">
              $49.900 ARS
            </div>
            <div className="text-4xl md:text-6xl font-black text-brand-dark mb-3 md:mb-6" data-id="element-224">
              $19.990{' '}
              <span className="text-lg md:text-2xl text-gray-500" data-id="element-225">ARS</span>
            </div>
            <CTAButton text="🔥 → QUIERO EL PACK AHORA" isLink={true} className="text-base md:text-xl py-3.5 md:py-5 w-full" data-id="element-226" />
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-3 md:gap-10 text-[10px] md:text-base text-blue-50 font-bold bg-white/10 backdrop-blur-sm py-4 md:py-8 px-4 md:px-6 rounded-2xl shadow-sm border border-white/20 mt-4 md:mt-12 max-w-3xl mx-auto" data-id="element-227">
          <span className="flex items-center gap-1.5" data-id="element-228">
            <LockIcon className="w-4 h-4 md:w-6 md:h-6 text-brand-primary" data-id="element-229" />{' '}
            Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-230">
            <ZapIcon className="w-4 h-4 md:w-6 md:h-6 text-brand-amber" data-id="element-231" />{' '}
            Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-232">
            <ShieldCheckIcon className="w-4 h-4 md:w-6 md:h-6 text-brand-green" data-id="element-233" />{' '}
            Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5 w-full justify-center mt-1 md:mt-0 md:w-auto" data-id="element-234">
            <CreditCardIcon className="w-4 h-4 md:w-6 md:h-6 text-blue-300" data-id="element-235" />{' '}
            Mercado Pago | Tarjeta | Transf.
          </span>
        </div>
      </div>
    </section>;
}